module.exports = __webpack_public_path__ + "static/media/p_6_4.7bfdeb9b.png";